export enum ColorEnum {
    Black = '#000000',
    BLUE = '#1E429E',
    Blue50 = '#EBF6FA',
    Blue100 = '#D2EDF7',
    Blue200 = '#A6DDF3',
    Blue300 = '#D2EDF7',
    BLUE_400 = '#63C1F0',
    BLUE_500 = '#06AED5',
    Blue600 = '#0593B3',
    Brick50 = '#FFF5F7',
    Brick100 = '#FDD8DE',
    BRICK_200 = '#FBB1BE',
    Brick300 = '#F8778D',
    BRICK_500 = '#E90C31',
    BRICK_600 = '#C00A27',
    BRICK_700 = '#9B0821',
    EMERALD_100 = '#DFF7EB',
    EMERALD_200 = '#BEEED6',
    EMERALD_500 = '#33C47C',
    Emerald600 = '#2DAC6C',
    EMERALD_700 = '#26925C',
    GRAY_100 = '#F9F9F9',
    GRAY_200 = '#EBEBEB',
    Gray250 = '#D9D9D9',
    GRAY_300 = '#CCCCCC',
    GRAY_400 = '#A3A3A3',
    GRAY_500 = '#7A7A7A',
    GRAY_600 = '#555555',
    GRAY_900 = '#231F20',
    JET_100 = '#778592',
    JET_500 = '#5B6671',
    JET_600 = '#40474F',
    Jet700 = '#2B2F35',
    JET_800 = '#212529',
    JET_900 = '#212529',
    RED_500 = '#FF0000',
    RED_600 = '#CD2B00',
    VIOLET_100 = '#F5F3F5',
    Violet150 = '#F0EDF0',
    VIOLET_200 = '#DAD3DA',
    Violet300 = '#BEB1BE',
    WHITE = '#FFFFFF',
    Yellow100 = '#FFF7E1',
    YELLOW_200 = '#FFEEC2',
    YELLOW_400 = '#FFCB47',
    YELLOW_500 = '#FFBA08',
    YELLOW_600 = '#E0A100',
    Yellow700 = '#B97C00',
    Transparent = 'transparent',
}
